import React from 'react';
import { colors } from '../utils/colors';
interface ConfidenceIndicatorProps {
  score: number;
  size?: 'sm' | 'md' | 'lg';
}
const ConfidenceIndicator: React.FC<ConfidenceIndicatorProps> = ({
  score,
  size = 'md'
}) => {
  // Use the new color scheme with different opacities based on confidence
  const getColor = () => {
    if (score >= 80) return colors.primary.dark;
    if (score >= 60) return colors.primary.medium;
    if (score >= 40) return colors.primary.light;
    return colors.ui.lightTeal;
  };
  const getSize = () => {
    switch (size) {
      case 'sm':
        return 'text-xs px-1.5 py-0.5';
      case 'lg':
        return 'text-sm px-3 py-1';
      default:
        return 'text-xs px-2 py-0.5';
    }
  };
  return <div className={`rounded-full ${getSize()} text-white font-medium inline-flex items-center`} style={{
    backgroundColor: getColor()
  }} data-id="element-16">
      <span data-id="element-17">{score}% confidence</span>
    </div>;
};
export default ConfidenceIndicator;